var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import moment from "moment-timezone";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import ReportQuery from "@irati/insights/apollo/query/report/get";
import { REPORT_STATUSES } from "@irati-web/insights/src/utils/constants/report";
import ErrorText from "@irati/ui/src/ErrorText";
import CreateInsightsReportCSV from "@irati/internal/apollo/mutation/CreateInsightsReportCSV";
import { ExportButton, LoadingButton, DownloadButton } from "./styled";
var POLL_INTERVAL = 500;
var CreateCSV = /** @class */ (function (_super) {
    __extends(CreateCSV, _super);
    function CreateCSV() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isPolling: false
        };
        _this.getMutationParams = function (_a) {
            var tenantUuid = _a.tenantUuid, cycleId = _a.cycleId;
            var displayTimezone = moment.tz.guess();
            return {
                tenantUuid: tenantUuid,
                cycleId: cycleId,
                displayTimezone: displayTimezone,
                reportType: "insights-cycle-comments",
                exportType: "csv"
            };
        };
        _this.updatePolling = function (isPolling) {
            _this.setState({ isPolling: isPolling });
        };
        return _this;
    }
    CreateCSV.prototype.render = function () {
        var _a = this.props, tenantUuid = _a.tenantUuid, cycleId = _a.cycleId, count = _a.count, formatMessage = _a.formatMessage;
        var isPolling = this.state.isPolling;
        return (React.createElement(CreateInsightsReportCSV, { variables: { params: this.getMutationParams({ tenantUuid: tenantUuid, cycleId: cycleId }) } }, function (createReport, _a) {
            var mutationLoading = _a.loading, error = _a.error, data = _a.data;
            var loading = mutationLoading || isPolling;
            var shouldShowError = !mutationLoading && error;
            if (loading) {
                return React.createElement(LoadingButton, { small: true, load: new Promise(function () { }) });
            }
            else if (!data) {
                return (React.createElement(React.Fragment, null,
                    shouldShowError && React.createElement(ErrorText, null, error && error.message),
                    React.createElement(ExportButton, { small: true, onClick: createReport },
                        React.createElement(FormattedMessage, { id: "insights.analysis.comments.exportCommentsButton", values: { count: count } }))));
            }
            else {
                return (React.createElement(ReportQuery, { variables: { uuid: data.createReport.uuid }, pollInterval: POLL_INTERVAL, useLoader: false }, function (_a) {
                    var report = _a.report, stopPolling = _a.stopPolling;
                    if (report) {
                        var status = report.status;
                        if (status === REPORT_STATUSES.failed) {
                            stopPolling();
                            return React.createElement(ErrorText, null, formatMessage({ id: "insights.analysis.comments.errorReport" }));
                        }
                        if (status === REPORT_STATUSES.complete) {
                            stopPolling();
                            return (React.createElement(DownloadButton, { small: true, href: report.resultFileUrl }, formatMessage({ id: "insights.analysis.comments.downloadReport" })));
                        }
                    }
                    return React.createElement(LoadingButton, { small: true, load: new Promise(function () { }) });
                }));
            }
        }));
    };
    return CreateCSV;
}(PureComponent));
export default injectIntl(CreateCSV);
